/* eslint-disable jsx-a11y/iframe-has-title */
import React from "react";
import ContactFrom from "../ContactFrom/ContactFrom";
import "./Contact.css";

const Contact = () => {
  return (
    <div
      id="contact"
      className="contact-details container mt-5 d-flex justify-content-center text-link-color"
    >
      <div className="">
        <div className="">
          <h2 class="text-center">Contact Me</h2>
          <hr className="horizantel-line" />
        </div>
        <div className="row">
          <div className="col-md-5">
            <ContactFrom></ContactFrom>
          </div>
          <div className="col-md-7 d-flex justify-content-center">
            <div className="">
              <h4 className="mt-4">
                Name: <small className="text-size">Md Maruf</small>
              </h4>
              <h4 className="mt-4">
                Email:{" "}
                <small className="text-size">
                  <a
                    className="contact-link-style"
                    href="mailto:ehsanmaruf489@gmail.com"
                  >
                    ehsanmaruf489@gmail.com
                  </a>
                </small>
              </h4>
              <h4 className="mt-4">
                Phone:{" "}
                <small className="text-size">
                  <a className="contact-link-style" href="tel:+8801841181011">
                    +880 1611156651
                  </a>
                </small>
              </h4>
              <h4 className="mt-4">
                LinkedIn:{" "}
                <small className="text-size">
                  <a
                    className="contact-link-style"
                    target="_blank"
                    href="https://www.linkedin.com/in/ehsan-maruf-086577240/"
                    rel="noreferrer"
                  >
                    dev_maruf
                  </a>
                </small>
              </h4>
              <h4 className="mt-4">
                Github:{" "}
                <small className="text-size">
                  <a
                    className="contact-link-style"
                    target="_blank"
                    href="https://github.com/ehsanmaruf"
                    rel="noreferrer"
                  >
                    dev_maruf
                  </a>
                </small>
              </h4>
              <h4 className="mt-4">
                Address:{" "}
                <small className="text-size">Kuril,Vatara,Dhaka-1229</small>
              </h4>
            </div>
          </div>
          <div className="col-12 p-2">
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d7299.898186650116!2d90.42320735!3d23.820409199999997!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3755c64e5249ad39%3A0x2392867b037e718e!2sKuril%2C%20Dhaka!5e0!3m2!1sen!2sbd!4v1680166223183!5m2!1sen!2sbd"
              width="100%"
              height="450"
              style={{ border: "0", borderRadius: "10px" }}
              allowfullscreen=""
              loading="lazy"
            ></iframe>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Contact;
